<template>
  <div class="month-report-manage">
    <!-- 导航提示标题 -->
    <ml-tip :showHeader="false" content="考核月度报表" />

    <!-- 搜索框 -->
    <ml-tip :showHeader="false" style="border: 0">
      <ml-form inline labelWidth="100px" :model="searchData" ref="searchDataRef">
        <!-- 阿米巴 -->
        <ml-select
          prop="companyId"
          placeholder="请选择阿米巴"
          :options="unitOptions"
          style="margin-bottom: 10px"
          label="阿米巴:"
          keyName="companyId"
          labelName="companyName"
          valueName="companyId"
          v-model="searchData.companyId"
          @change="selectUnit"
        />

        <!-- 年月 -->
        <ml-date-picker
          prop="reportMonth"
          type="month"
          placeholder="请选择年月"
          label="年月:"
          valueFormat="YYYY-MM"
          format="YYYY年MM月"
          :clearable="false"
          v-model="searchData.reportMonth"
          style="margin-bottom: 10px; margin-right: 40px"
        />

        <!-- 搜索按钮 -->
        <ml-button
          :style="{ 'margin-bottom': 0 }"
          submitText="查询"
          submitIcon="el-icon-search"
          cancelText="重置"
          cancelIcon="el-icon-refresh"
          cancelType="danger"
          @click-cancel="resetSearchData"
          @click-submit="searchFn"
        />
        <el-button icon="el-icon-upload2" type="primary" @click="clickImport"> 导入 </el-button>
        <el-button icon="el-icon-download" type="warning" @click="clickExport"> 导出 </el-button>
      </ml-form>
    </ml-tip>

    <!-- 数据表格 -->
    <div class="default-tip" :showHeader="false" style="margin-bottom: 0; border: 0">
      <!-- 表格 -->
      <el-table :data="tabberData.data" style="width: 100%" :height="tabberHeight(310)">
        <el-table-column align="center" type="index" width="80">
          <template #default="scope">
            {{ (tabberData.page - 1) * tabberData.size + (scope.$index + 1) }}
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="运维人员"
          prop="userName"
          min-width="100px"
          show-overflow-tooltip
        />

        <el-table-column
          align="center"
          label="所属阿米巴"
          prop="companyName"
          min-width="120px"
          show-overflow-tooltip
        />

        <el-table-column align="center" label="当月有效工作日" prop="weekdays" min-width="150px" />

        <el-table-column align="center" label="巡检工单数量" prop="inspectNum" min-width="130px" />

        <el-table-column align="center" label="故障工单数量" prop="errorNum" min-width="130px" />

        <el-table-column
          align="center"
          label="有效工单数量"
          prop="apprErrorNum"
          min-width="130px"
        />

        <el-table-column
          align="center"
          label="本月工单完成率"
          prop="completeRate"
          min-width="130px"
        >
          <template #default="scope">
            {{
              scope.row.completeRate !== null
                ? (scope.row.completeRate * 100).toFixed(1) + '%'
                : '-'
            }}
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="工单完成数量得分"
          prop="completeScore"
          min-width="150px"
        />

        <el-table-column
          align="center"
          label="工单完成质量得分"
          prop="completeQualityScore"
          min-width="150px"
        />

        <el-table-column align="center" label="遵守制度(满分20分)" prop="cwr" min-width="90px">
          <template #default="scope">
            {{ scope.row.cwr !== null ? scope.row.cwr : '-' }}
          </template>
        </el-table-column>

        <el-table-column align="center" label="服从安排(满分20分)" prop="fta" min-width="90px">
          <template #default="scope">
            {{ scope.row.fta !== null ? scope.row.fta : '-' }}
          </template>
        </el-table-column>

        <el-table-column align="center" label="实际得分" prop="sumScore" min-width="100px" />

        <el-table-column align="center" label="操作" min-width="100px">
          <template #default="scope">
            <el-button size="mini" type="primary" @click="clickEdit(scope.$index, scope.row)">
              编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <ml-pagination
        :total="tabberData.total"
        :page="tabberData.page"
        v-model="tabberData.page"
        :size="tabberData.size"
        @current-change="currentChange"
        @size-change="sizeChange"
      />
    </div>

    <!-- 导入对话框 -->
    <ml-dialog width="600px" ref="importDialogRef" title="批量导入" :showSubmitBtn="false">
      <template #body>
        <div class="import-dialog-box">
          <div class="import-dialog-item">
            <span>请选择导入的文件:</span>
            <ml-upload
              :showFileList="false"
              ref="importUploadRef"
              @on-change="onChange"
              accept=".xls, .xlsx"
            >
              <el-button icon="el-icon-upload2" type="primary">批量导入</el-button>
            </ml-upload>
          </div>
          <div class="import-dialog-item">
            <span>还没有模板？</span>
            <el-button type="text" @click="downloadTemplate">点击下载模板</el-button>
          </div>
        </div>
      </template>
    </ml-dialog>

    <!-- 编辑对话框 -->
    <ml-dialog
      width="600px"
      ref="editDialogRef"
      title="编辑考核报表"
      :btnLoading="btnLoading"
      @click-submit="submitEdit"
    >
      <template #body>
        <ml-form
          style="width: 100%; padding: 0 20px"
          labelWidth="150px"
          :model="editData"
          ref="editFormRef"
          :rules="editFormRules"
        >
          <!-- 运维人员 -->
          <ml-input
            prop="userName"
            label="运维人员:"
            placeholder="运维人员"
            v-model="editData.userName"
            disabled
          />
          <!-- 所属阿米巴 -->
          <ml-input
            prop="companyName"
            label="所属阿米巴:"
            placeholder="所属阿米巴"
            v-model="editData.companyName"
            disabled
          /><!-- 年月 -->
          <ml-date-picker
            prop="reportMonth"
            type="month"
            placeholder="请选择年月"
            label="年月:"
            valueFormat="YYYY-MM"
            format="YYYY年MM月"
            :clearable="false"
            v-model="editData.reportMonth"
          />
          <!-- 遵守制度(满分20分) -->
          <ml-input-number
            prop="cwr"
            label="遵守制度(满分20分):"
            placeholder="请输入遵守制度得分"
            v-model="editData.cwr"
            :min="0"
            :max="20"
            :precision="0"
          />
          <!-- 服从安排(满分20分) -->
          <ml-input-number
            prop="fta"
            label="服从安排(满分20分):"
            placeholder="请输入服从安排得分"
            v-model="editData.fta"
            :min="0"
            :max="20"
            :precision="0"
            style="margin-bottom: 0"
          />
        </ml-form>
      </template>
    </ml-dialog>
  </div>
</template>

<script>
import { onMounted, reactive, ref, watch } from 'vue'
import { tabberHeight, getTabberData } from '@/utils'
import { useStore } from 'vuex'
import { MONTHDOWNLOADTEMPLATE } from '@/API'
import { exportMonthReportRequest } from '@/API/previewApi'
import { downloadFile } from '@/utils'

export default {
  name: 'MonthReportManage',
  setup() {
    const { commit, dispatch } = useStore()

    /* 开始 搜索 **********************************/
    // 获取当前年月
    const getCurrentMonth = () => {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      return `${year}-${month}`
    }

    // 搜索条件
    const searchDataRef = ref()
    const searchData = reactive({
      companyId: '',
      reportMonth: getCurrentMonth()
    })

    // 阿米巴列表
    const unitOptions = ref([])

    // 选择阿米巴
    const selectUnit = () => {
      searchFn()
    }

    // 重置搜索内容（只重置阿米巴，保留年月）
    const resetSearchData = () => {
      searchDataRef.value.CustomFormRef.resetFields()
      searchData.companyId = ''
      searchData.reportMonth = getCurrentMonth()
      tabberData.page === 1 ? getTableData() : (tabberData.page = 1)
    }

    // 搜索
    const searchFn = () => {
      tabberData.page === 1 ? getTableData() : (tabberData.page = 1)
    }
    /* 结束 搜索 **********************************/

    /* 开始 数据列表 **********************************/
    // 表格配置
    const tabberData = reactive({
      data: [],
      total: 0,
      page: 1,
      size: 20
    })

    // 监听分页变化
    watch([() => tabberData.page, () => tabberData.size], () => {
      getTableData()
    })

    // 获取列表数据
    const getTableData = async () => {
      const params = {
        companyId: searchData.companyId || '',
        reportMonth: searchData.reportMonth || '',
        pageIndex: tabberData.page,
        pageSize: tabberData.size
      }
      const { data } = await getTabberData(dispatch, 'fetchGetMonthReportPage', params)
      tabberData.data = data?.records || []
      tabberData.total = data?.total || 0
    }

    // 分页事件
    const currentChange = page => {
      tabberData.page = page
    }
    const sizeChange = size => {
      tabberData.size = size
      tabberData.page = 1
    }

    /* 结束 数据列表 **********************************/

    /* 开始 编辑弹窗 **********************************/
    // 编辑弹窗数据
    const editData = reactive({
      id: '',
      userId: '',
      userName: '',
      companyId: '',
      companyName: '',
      reportMonth: '',
      cwr: null,
      fta: null
    })

    // 编辑表单验证规则
    const editFormRules = {
      reportMonth: [{ required: true, message: '请选择年月', trigger: 'change' }],
    }

    // 按钮加载状态
    const btnLoading = ref(false)

    // 编辑弹窗引用
    const editDialogRef = ref()
    const editFormRef = ref()

    // 点击编辑
    const clickEdit = (index, row) => {
      editData.id = row.id
      editData.userId = row.userId
      editData.userName = row.userName
      editData.companyId = row.companyId
      editData.companyName = row.companyName
      editData.reportMonth = row.reportMonth
      editData.cwr = row.cwr
      editData.fta = row.fta
      editDialogRef.value.showDialog = true
    }

    // 提交编辑
    const submitEdit = () => {
      editFormRef.value.CustomFormRef.validate().then(() => {
        btnLoading.value = true
        const params = {
          id: editData.id,
          userId: editData.userId,
          reportMonth: editData.reportMonth,
          cwr: editData.cwr || 0,
          fta: editData.fta || 0
        }
        dispatch('fetchUpdateMonthReport', params).then(data => {
          btnLoading.value = false
          if (data && data.code === 200) {
            editDialogRef.value.showDialog = false
            getTableData()
          }
          commit('setError', {
            status: true,
            title: data.message,
            message: data.code === 200 ? '保存成功' : '保存失败',
            type: data.code === 200 ? 'success' : 'error'
          })
        })
      })
    }
    /* 结束 编辑弹窗 **********************************/

    /* 开始 导入导出 **********************************/
    // 导入弹窗
    const importDialogRef = ref()
    const importUploadRef = ref()
    const clickImport = () => {
      importDialogRef.value.showDialog = true
    }

    // 文件选择变化
    const onChange = (ev, file) => {
      if (file && file.length > 0) {
        const ImportFormData = new FormData()
        ImportFormData.append('file', file[0].raw)
        importUploadRef.value.CustomUploadRef.uploadFiles = []
        dispatch('fetchImportMonthReport', ImportFormData).then(data => {
          if (data && data.code === 200) {
            tabberData.page === 1 ? getTableData() : (tabberData.page = 1)
            importDialogRef.value.showDialog = false
          }
          commit('setError', {
            status: true,
            title: data.message,
            message: '正在获取新的数据...',
            type: 'success'
          })
        })
      }
    }

    // 下载模板
    const downloadTemplate = () => {
      window.location.href = `${MONTHDOWNLOADTEMPLATE}`
    }

    // 导出
    const clickExport = () => {
      const params = {
        companyId: searchData.companyId || '',
        reportMonth: searchData.reportMonth || '',
        pageIndex: 1,
        pageSize: 9999
      }
      exportMonthReportRequest(params)
        .then(res => {
          let fileName = '考核月度报表.xlsx'
          downloadFile(res.data, fileName)
        })
        .catch(error => {})
    }
    /* 结束 导入导出 **********************************/

    onMounted(async () => {
      // 获取阿米巴列表
      const { data } = await getTabberData(dispatch, 'fetchGetCompanyInfos', {})
      unitOptions.value = data || []
      getTableData()
    })

    return {
      searchDataRef,
      searchData,
      unitOptions,
      selectUnit,
      resetSearchData,
      searchFn,
      tabberData,
      currentChange,
      sizeChange,
      tabberHeight,
      clickEdit,
      editData,
      editFormRules,
      btnLoading,
      editDialogRef,
      editFormRef,
      submitEdit,
      importDialogRef,
      importUploadRef,
      clickImport,
      onChange,
      downloadTemplate,
      clickExport
    }
  }
}
</script>

<style lang="scss" scoped>
.month-report-manage {
  @extend %params-global;
}
.default-tip {
  padding-bottom: 27px;
}

.import-dialog-box {
  width: 100%;
  padding: 0 20px;

  .import-dialog-item {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    span {
      margin-right: 20px;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
